import { render, staticRenderFns } from "./PowerUpCustomModal.vue?vue&type=template&id=5b74ba20&scoped=true"
import script from "./PowerUpCustomModal.vue?vue&type=script&lang=js"
export * from "./PowerUpCustomModal.vue?vue&type=script&lang=js"
import style0 from "./PowerUpCustomModal.vue?vue&type=style&index=0&id=5b74ba20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b74ba20",
  null
  
)

export default component.exports